import WebFont from 'webfontloader'
import styled from 'styled-components'

import { Container, Col, Columns, Box } from '@redriverpress/system'

import ElliiThemeProvider from 'Common/components/ElliiThemeProvider'

import Footer from '../common/components/Footer'
import Navbar from '../common/components/Navbar'
import Sidebar from './components/Sidebar'
import SignInForm from './components/SignInForm'

import { SignInProvider } from './context/sign-in'

const SidebarBackground = styled(Box).attrs(() => ({
  bg: 'gray50',
  position: 'absolute',
  top: 0,
  bottom: 0,
  zIndex: -1,
  right: 0,
}))``

export default function App() {
  WebFont.load({
    google: {
      families: ['Open Sans:400italic,300,400,600,600italic,700,700italic'],
    },
  })

  return (
    <SignInProvider>
      <ElliiThemeProvider>
        <Box position='relative'>
          <SidebarBackground
            width={1 / 3}
            display={['none', null, null, 'block']}
          />
          <Container minHeight={[null, null, null, '100vh']}>
            <Columns>
              <Col width={[1, null, 2 / 3]}>
                <Navbar signIn={false} />
              </Col>
              <Col
                width={1 / 3}
                bg='gray50'
                display={['none', null, null, 'block']}
              />
            </Columns>

            <Columns justifyContent='center'>
              <Col
                width={[1, null, 2 / 3]}
                display='flex'
                flexDirection='column'
                pt={[4, null, 5]}
                position='relative'
              >
                <Columns
                  justifyContent={['center', null, null, null, 'start']}
                  height='100%'
                >
                  <Col
                    width={1 / 4}
                    display={['none', null, null, null, 'block']}
                  />
                  <Col
                    width={[1, null, null, 3 / 4, 5 / 8]}
                    display='flex'
                    flexDirection='column'
                  >
                    <SignInForm />

                    <Footer
                      color='gray800'
                      mt={[null, null, null, 'auto']}
                      mb={[null, null, null, 2, 4]}
                      py={4}
                    />
                  </Col>
                </Columns>
              </Col>
              <Col
                width={1 / 3}
                pt={5}
                bg='gray50'
                display={['none', null, null, 'block']}
              >
                <Sidebar pl={[3, null, null, null, 4]} />
              </Col>
            </Columns>
          </Container>
        </Box>
        <Box bg='gray50' display={['block', null, null, 'none']}>
          <Container>
            <Columns justifyContent='center'>
              <Col width={[1, null, 2 / 3]} pt={4}>
                <Sidebar />
              </Col>
            </Columns>
          </Container>
        </Box>
      </ElliiThemeProvider>
    </SignInProvider>
  )
}
